const traditional = [
  'Pagos altos por cada persona',
  'Amarrado a una sola funeraria',
  'Contratos largos y compromisos forzosos',
  'Decisiones presenciales bajo presion',
];

const coverly = [
  'Una sola membresia mensual desde $289',
  'Titular y personas registradas en una sola app',
  'Coordinacion con funerarias aliadas de prestigio',
  'Claridad de pagos, plan y personas registradas',
  'Sin contratos forzosos',
];

export default function CostComparison() {
  const goToCta = () => {
    const el = document.getElementById('cta-final');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="comparacion" className="bg-[#12101C] py-14 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex rounded-full border border-white/15 px-4 py-2 text-xs font-black uppercase tracking-wide text-[#C9C3FF]">
            Comparativa
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-white md:text-5xl">
            Coverly vs. plan funerario tradicional
          </h2>
          <p className="mt-5 text-base leading-8 text-white/55 md:text-lg">
            La diferencia no es solo el precio. Es tener claridad antes, control desde el celular y apoyo cuando se necesita.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <article className="rounded-[30px] border border-white/10 bg-white/[0.03] p-6 md:p-8">
            <p className="text-xs font-black uppercase tracking-wide text-white/35">Modelo tradicional</p>
            <h3 className="mt-4 text-2xl font-black text-white/65">Compra directa con funeraria</h3>
            <ul className="mt-7 space-y-4">
              {traditional.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm font-semibold text-white/45">
                  <i className="ri-alert-line mt-0.5 text-[#FF9D9D]" />
                  {item}
                </li>
              ))}
            </ul>
          </article>

          <article className="rounded-[30px] border border-[#8B83EA] bg-gradient-to-br from-[#5B51C9] to-[#332C85] p-6 shadow-2xl shadow-[#534AB7]/20 md:p-8">
            <p className="text-xs font-black uppercase tracking-wide text-[#D9D5FF]">La mejor opcion</p>
            <div className="mt-4 flex items-end justify-between gap-4">
              <h3 className="text-2xl font-black text-white">Membresia Coverly</h3>
              <p className="rounded-full bg-white/12 px-4 py-2 text-sm font-black text-white">Desde $289/mes</p>
            </div>
            <ul className="mt-7 space-y-4">
              {coverly.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm font-semibold text-white">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-white/15">
                    <i className="ri-check-line text-xs text-white" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <button
              onClick={goToCta}
              className="mt-8 w-full rounded-2xl bg-white px-5 py-4 text-sm font-black text-[#534AB7] transition-transform hover:scale-[1.01]"
            >
              Quiero Coverly
            </button>
          </article>
        </div>
      </div>
    </section>
  );
}
